import { useSelector } from 'react-redux';
import ScrollToContinue from './ScrollToContinue/ScrollToContinue';
import classes from './Hero.module.css';
import isMobileViewHook from '../../hooks/isMobileView';

const Hero = () => {
  const isMobileView = isMobileViewHook();
  const hub = useSelector((state) => state.hub.hub);
  if (!hub) return null;
  const { hero, heroMobile } = hub;
  return (
    <>
      <div className={classes.hero}>
        <img
          className={classes.imageHero}
          alt="title"
          src={isMobileView ? heroMobile[0].url : hero[0].url}
        />
        {!isMobileView && <ScrollToContinue />}
      </div>
      {isMobileView && <ScrollToContinue />}
    </>
  );
};

export default Hero;
